import { LoadingOutlined } from "@ant-design/icons";
import { Input, Form, Space, Button, Spin } from "antd";
import React, { useState } from "react";

import { COLORS } from "../../../constants";
import { updateFAQ } from "../../http-request/faq";

const antIcon = (
  <LoadingOutlined style={{ fontSize: 20, color: COLORS.blue1 }} spin />
);

const FormFields = (props) => {
  const [isLoading, setisLoading] = useState(false);
  return (
    <Form
      onFinish={async (data) => {
        setisLoading(true);
        await updateFAQ({ faqId: props._id, data })
          .then(() => {
            props.loadFAQ();
          })
          .finally(() => setisLoading(false));
      }}
    >
      <Form.Item
        name={"title"}
        rules={[
          {
            required: true,
            message: "Please input title!",
          },
        ]}
      >
        <Input placeholder="Enter New FAQ Title..." />
      </Form.Item>
      <Form.Item
        name={"text"}
        rules={[
          {
            required: true,
            message: "Please input text!",
          },
        ]}
      >
        <Input.TextArea placeholder="Enter New FAQ Text..." />
      </Form.Item>
      <Space direction="horizontal" size={"middle"}>
        <Button
          disabled={isLoading}
          block
          htmlType="submit"
          type="primary"
          color={COLORS.orange}
        >
          {isLoading ? <Spin indicator={antIcon} /> : "SAVE"}
        </Button>
        <Button
          onClick={() => props._isEditing()}
          disabled={isLoading}
          block
          htmlType="reset"
          type="primary"
          style={{ backgroundColor: COLORS.orange, border: 0 }}
        >
          DISCARD
        </Button>
      </Space>
    </Form>
  );
};

export default FormFields;
